import { initGraphQLTada } from 'gql.tada'
// Through src so the emitted dist/gql/graphql.d.ts resolves it too: tsc never copies a .d.ts input.
import type { introspection } from '../../src/gql/graphql-env'

export const graphql = initGraphQLTada<{
    introspection: introspection
    scalars: {
        MRN: string
    }
}>()
